import { TOKEN_IDS } from "@/types";
import { ASSET_URLS } from "@/components/shared";

enum IntegrationOpportunityKey {
    ALL = "all",
    LP = "lp",
    VAULTS = "vaults",
}

enum IntegrationProtocolKey {
    CURVE = "Curve",
    FLUID = "Fluid",
    INFINIFI = "infiniFi",
    TAU = "Tau",
    PENDLE = "Pendle",
    SEAMLESS = "Seamless",
}

export const INTEGRATION_FILTERS = {
    TASK_TYPE: {
        [IntegrationOpportunityKey.ALL]: "All",
        [IntegrationOpportunityKey.LP]: "Liquidity Pools",
        [IntegrationOpportunityKey.VAULTS]: "Vaults",
    },
    PROTOCOL: {
        [IntegrationProtocolKey.CURVE]: "Curve",
        [IntegrationProtocolKey.FLUID]: "Fluid",
        [IntegrationProtocolKey.INFINIFI]: "infiniFi",
        [IntegrationProtocolKey.TAU]: "Tau",
        [IntegrationProtocolKey.PENDLE]: "Pendle",
        [IntegrationProtocolKey.SEAMLESS]: "Seamless",
    },
    ASSET: TOKEN_IDS,
};

export const INTEGRATION_PROTOCOLS = {
    balancer: {
        title: "Balancer",
        logo: ASSET_URLS.BALANCER,
    },
    curve: {
        title: "Curve",
        logo: ASSET_URLS.CURVE,
    },
    ethena: {
        title: "Ethena",
        logo: ASSET_URLS.ETHENA,
    },
    fluid: {
        title: "Fluid",
        logo: ASSET_URLS.FLUID,
    },
    gearbox: {
        title: "Gearbox",
        logo: ASSET_URLS.GEARBOX,
    },
    infinifi: {
        title: "infiniFi",
        logo: ASSET_URLS.INFINIFI_CIRC,
    },
    morpho: {
        title: "Morpho",
        logo: ASSET_URLS.MORPHO,
    },
    odyssey: {
        title: "Odyssey",
        logo: ASSET_URLS.ODYSSEY,
    },
    pendle: {
        title: "Pendle",
        logo: ASSET_URLS.PENDLE,
    },
    seamless: {
        title: "Seamless",
        logo: ASSET_URLS.SEAMLESS,
    },
    silo: {
        title: "Silo",
        logo: ASSET_URLS.SILO,
    },
    strata: {
        title: "Strata",
        logo: ASSET_URLS.STRATA,
    },
    tau: {
        title: "Tau",
        logo: ASSET_URLS.TAU,
    },
};

export const INTEGRATION_PROTOCOL_KEYS = Object.keys(INTEGRATION_PROTOCOLS);
